import {  apiGet } from '../../utils'

export function getElecAgentDeivcesHistoryDetailsAPI(id) {
    return apiGet(`/api/electrician/device/get-info?device_id=${id}`)
}